// import React from 'react';
// import { Page, Text, View, Document, StyleSheet, Image, Link } from '@react-pdf/renderer';
// import logo from '../../images/57logo.jpeg';
// import { formatDateTimeAuto } from '../Utils/Utils';

// const styles = StyleSheet.create({
//     page: {
//         padding: 30,
//         fontFamily: 'Helvetica',
//     },
//     header: {
//         flexDirection: 'row',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         marginBottom: 20,
//         borderBottomWidth: 2,
//         borderBottomColor: '#112131',
//         paddingBottom: 10,
//     },
//     companyInfo: {
//         flexDirection: 'column',
//         alignItems: 'flex-end',
//     },
//     logo: {
//         width: 100,
//         height: 80,
//     },
//     title: {
//         fontSize: 20,
//         fontWeight: 'bold',
//         color: '#112131',
//     },
//     subtitle: {
//         fontSize: 10,
//         color: '#666',
//     },
//     table: {
//         display: 'flex',
//         width: 'auto',
//         marginTop: 20,
//     },
//     tableHeader: {
//         flexDirection: 'row',
//         backgroundColor: '#112131',
//         color: 'white',
//     },
//     tableRow: {
//         flexDirection: 'row',
//         borderBottomWidth: 1,
//         borderBottomColor: '#eee',
//         alignItems: 'flex-start',
//         minHeight: 28,
//         paddingVertical: 4,
//     },
//     tableCell: {
//         padding: 4,
//         fontSize: 9,
//         flex: 1,
//         textAlign: 'left',
//         wordBreak: 'break-word',
//     },
//     tableCellHeader: {
//         padding: 4,
//         fontSize: 9,
//         fontWeight: 'bold',
//         flex: 1,
//         textAlign: 'left',
//         color: 'white',
//     },
//     footer: {
//         position: 'absolute',
//         bottom: 30,
//         left: 30,
//         right: 30,
//         fontSize: 10,
//         textAlign: 'center',
//         color: '#666',
//         borderTopWidth: 1,
//         borderTopColor: '#eee',
//         paddingTop: 10,
//     },
// });

// const DayAttendancePDF = ({ presentUsers, sites }) => {
//     const date = new Date();
//     const day = String(date.getDate()).padStart(2, '0');
//     const month = String(date.getMonth() + 1).padStart(2, '0');
//     const year = date.getFullYear();
//     const currentDate = `${day}/${month}/${year}`;

//     return (
//         <Document>
//             <Page size="A4" style={styles.page}>
//                 {/* Header */}
//                 <View style={styles.header}>
//                     <View>
//                         <Text style={styles.title}>{currentDate} - Attendance Report</Text>
//                     </View>
//                     <View style={styles.companyInfo}>
//                         <Image style={styles.logo} src={logo} />
//                         <Text style={styles.subtitle}>57Peace Protection Limited</Text>
//                     </View>
//                 </View>

//                 {/* Table */}
//                 <View style={styles.table}>
//                     <View style={styles.tableHeader}>
//                         <Text style={[styles.tableCellHeader, { flex: 0.5 }]}>#</Text>
//                         <Text style={[styles.tableCellHeader, { flex: 1 }]}>Staff ID</Text>
//                         <Text style={[styles.tableCellHeader, { flex: 2 }]}>Name</Text>
//                         <Text style={[styles.tableCellHeader, { flex: 2 }]}>NRIC / FIN</Text>
//                         <Text style={[styles.tableCellHeader, { flex: 2 }]}>Grade</Text>
//                         <Text style={[styles.tableCellHeader, { flex: 2 }]}>Duty</Text>
//                         <Text style={[styles.tableCellHeader, { flex: 2 }]}>Site</Text>
//                         <Text style={[styles.tableCellHeader, { flex: 1.2 }]}>Time-In</Text>
//                         <Text style={[styles.tableCellHeader, { flex: 1.2 }]}>Time-Out</Text>
//                         <Text style={[styles.tableCellHeader, { flex: 1.2 }]}>Total Hrs</Text>
//                         <Text style={[styles.tableCellHeader, { flex: 1.5 }]}>Time-In Location</Text>
//                         <Text style={[styles.tableCellHeader, { flex: 1.5 }]}>Time-Out Location</Text>
//                     </View>

//                     {presentUsers.map((user, index) => (
//                         <View style={styles.tableRow} key={index}>
//                             <Text style={[styles.tableCell, { flex: 0.5 }]}>{index + 1}</Text>
//                             <Text style={[styles.tableCell, { flex: 1 }]}>{user.userDetails?.employeeId || '-'}</Text>
//                             <Text style={[styles.tableCell, { flex: 2 }]}>
//                                 {`${user.userDetails?.firstName || ''} ${user.userDetails?.lastName || ''}`.trim() || '-'}
//                             </Text>
//                             <Text style={[styles.tableCell, { flex: 2 }]}>
//                                 {user.userDetails?.nricOrFin || '-'}
//                             </Text>
//                             <Text style={[styles.tableCell, { flex: 2 }]}>
//                                 {user.roleDetails?.[0]?.name || '-'}
//                             </Text>
//                             <Text style={[styles.tableCell, { flex: 2 }]}>
//                                 {user.dutyType}
//                             </Text>
//                             <Text style={[styles.tableCell, { flex: 2 }]}>
//                                 {(sites.find(site => site.id === user.site_id)?.name) || 'N/A'}
//                             </Text>
//                             <Text style={[styles.tableCell, { flex: 1.2 }]}>{user.entryTime ? formatDateTimeAuto(user.entryTime) : '-'}</Text>
//                             <Text style={[styles.tableCell, { flex: 1.2 }]}>{user.exitTime ? formatDateTimeAuto(user.exitTime) : '-'}</Text>
//                             <Text style={[styles.tableCell, { flex: 1.2 }]}>{user.totalHours || '-'}</Text>
//                             <Text style={[styles.tableCell, { flex: 1.5 }]}>
//                                 {user.entryMapUrl ? (
//                                     <Link src={user.entryMapUrl} style={{ color: '#0066cc' }}>View</Link>
//                                 ) : '-'}
//                             </Text>
//                             <Text style={[styles.tableCell, { flex: 1.5 }]}>
//                                 {user.exitMapUrl ? (
//                                     <Link src={user.exitMapUrl} style={{ color: '#0066cc' }}>View</Link>
//                                 ) : '-'}
//                             </Text>
//                         </View>
//                     ))}
//                 </View>

//                 {/* Footer */}
//                 <View style={styles.footer}>
//                     <Text>57Pease Protection Limited • {currentDate} • Confidential</Text>
//                 </View>
//             </Page>
//         </Document>
//     );
// };

// export default DayAttendancePDF;


import React from 'react';
import {
    Page,
    Text,
    View,
    Document,
    StyleSheet,
    Image,
    Link
} from '@react-pdf/renderer';
import logo from '../../images/57logo.jpeg';
import { formatDateTimeAuto } from '../Utils/Utils';

const styles = StyleSheet.create({
    page: {
        padding: 20,
        fontFamily: 'Helvetica',
        fontSize: 9,
    },

    /* ---------- HEADER ---------- */
    header: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 12,
        borderBottomWidth: 1.5,
        borderBottomColor: '#112131',
        paddingBottom: 8,
    },
    title: {
        fontSize: 16,
        fontWeight: 'bold',
        color: '#112131',
    },
    subtitle: {
        fontSize: 9,
        color: '#555',
    },
    logo: {
        width: 90,
        height: 65,
    },

    /* ---------- TABLE ---------- */
    table: {
        width: '100%',
        borderWidth: 1,
        borderColor: '#ccc',
    },

    tableHeader: {
        flexDirection: 'row',
        backgroundColor: '#112131',
    },

    headerCell: {
        padding: 5,
        color: '#fff',
        fontWeight: 'bold',
        borderRightWidth: 1,
        borderRightColor: '#fff',
        textAlign: 'center',
    },

    tableRow: {
        flexDirection: 'row',
        borderBottomWidth: 1,
        borderBottomColor: '#e0e0e0',
        minHeight: 28,
    },

    rowEven: {
        backgroundColor: '#f7f9fc',
    },

    cell: {
        padding: 5,
        borderRightWidth: 1,
        borderRightColor: '#e0e0e0',
        textAlign: 'left',
        wordBreak: 'break-word',
    },

    center: {
        textAlign: 'center',
    },

    /* ---------- FOOTER ---------- */
    footer: {
        position: 'absolute',
        bottom: 15,
        left: 20,
        right: 20,
        borderTopWidth: 1,
        borderTopColor: '#ccc',
        paddingTop: 6,
        fontSize: 9,
        textAlign: 'center',
        color: '#666',
    },
});

/* ---------- FIXED COLUMN WIDTHS ---------- */
const COL = {
    sNo: 30,
    staffId: 55,
    name: 90,
    nric: 85,
    grade: 70,
    duty: 70,
    site: 90,
    time: 65,
    hours: 55,
    location: 85,
};

const DayAttendancePDF = ({ presentUsers, sites }) => {
    const date = new Date();
    const currentDate = date.toLocaleDateString('en-GB');

    return (
        <Document>
            <Page size="A4" orientation="landscape" style={styles.page}>

                {/* ---------- HEADER ---------- */}
                <View style={styles.header}>
                    <View>
                        <Text style={styles.title}>{currentDate} – Attendance Report</Text>
                        <Text style={styles.subtitle}>Daily Attendance Summary</Text>
                    </View>
                    <View style={{ alignItems: 'flex-end' }}>
                        <Image src={logo} style={styles.logo} />
                        <Text style={styles.subtitle}>57Peace Protection Limited</Text>
                    </View>
                </View>

                {/* ---------- TABLE HEADER ---------- */}
                <View style={styles.table}>
                    <View style={styles.tableHeader}>
                        <Text style={[styles.headerCell, { width: COL.sNo }]}>#</Text>
                        <Text style={[styles.headerCell, { width: COL.staffId }]}>Staff ID</Text>
                        <Text style={[styles.headerCell, { width: COL.name }]}>Name</Text>
                        <Text style={[styles.headerCell, { width: COL.nric }]}>NRIC / FIN</Text>
                        <Text style={[styles.headerCell, { width: COL.grade }]}>Grade</Text>
                        <Text style={[styles.headerCell, { width: COL.duty }]}>Duty</Text>
                        <Text style={[styles.headerCell, { width: COL.site }]}>Site</Text>
                        <Text style={[styles.headerCell, { width: COL.time }]}>Time-In</Text>
                        <Text style={[styles.headerCell, { width: COL.time }]}>Time-Out</Text>
                        <Text style={[styles.headerCell, { width: COL.hours }]}>Hrs</Text>
                        <Text style={[styles.headerCell, { width: COL.location }]}>In-Loc</Text>
                        <Text style={[styles.headerCell, { width: COL.location }]}>Out-Loc</Text>
                    </View>

                    {/* ---------- TABLE ROWS ---------- */}
                    {presentUsers.map((user, index) => {
                        const userDetails = user.userDetails;
                     return(

                    <View
                        key={index}
                        style={[
                            styles.tableRow,
                            index % 2 === 0 && styles.rowEven
                        ]}
                    >
                        <Text style={[styles.cell, styles.center, { width: COL.sNo }]}>
                            {index + 1}
                        </Text>

                        <Text style={[styles.cell, { width: COL.staffId }]}>
                            {userDetails.employeeId ? userDetails?.employeeId : '#'}
                        </Text>

                        <Text style={[styles.cell, { width: COL.name }]}>
                            {userDetails.firstName
                                ? `${userDetails?.firstName || ''} ${userDetails?.lastName || ''}`.trim() || '-'
                                : user.staffName || '-'}
                        </Text>


                        <Text style={[styles.cell, { width: COL.nric }]}>
                            {userDetails.nricOrFin ? userDetails?.nricOrFin : user.nricOrFin}
                        </Text>

                        <Text style={[styles.cell, { width: COL.grade }]}>
                            {user.roleDetails?.[0]?.name || '-'}
                        </Text>

                        <Text style={[styles.cell, { width: COL.duty }]}>
                            {user.dutyType || '-'}
                        </Text>

                        <Text style={[styles.cell, { width: COL.site }]}>
                            {sites.find(s => s.id === user.site_id)?.name || 'N/A'}
                        </Text>

                        <Text style={[styles.cell, { width: COL.time }]}>
                            {user.entryTime ? formatDateTimeAuto(user.entryTime) : '-'}
                        </Text>

                        <Text style={[styles.cell, { width: COL.time }]}>
                            {user.exitTime ? formatDateTimeAuto(user.exitTime) : '-'}
                        </Text>

                        <Text style={[styles.cell, styles.center, { width: COL.hours }]}>
                            {user.totalHours || '-'}
                        </Text>

                        <Text style={[styles.cell, { width: COL.location }]}>
                            {user.entryMapUrl
                                ? <Link src={user.entryMapUrl}>View</Link>
                                : '-'}
                        </Text>

                        <Text style={[styles.cell, { width: COL.location }]}>
                            {user.exitMapUrl
                                ? <Link src={user.exitMapUrl}>View</Link>
                                : '-'}
                        </Text>
                    </View>
                    )})}
                </View>

                {/* ---------- FOOTER ---------- */}
                <View style={styles.footer}>
                    <Text>
                        57Peace Protection Limited • {currentDate} • Confidential
                    </Text>
                </View>

            </Page>
        </Document>
    );
};

export default DayAttendancePDF;

